export const GET_FIELDS_LIST_REQUEST = 'GET_FIELDS_LIST_REQUEST';
export const GET_FIELDS_LIST_SUCCESS = 'GET_FIELDS_LIST_SUCCESS';
export const GET_FIELDS_LIST_ERROR = 'GET_FIELDS_LIST_ERROR';
export const UPDATE_FIELDS_LIST_OPTIONS = 'UPDATE_FIELDS_LIST_OPTIONS';
export const CLEAR_FIELDS_LIST = 'CLEAR_FIELDS_LIST';
export const GET_FIELDS_ALL_REQUEST = 'GET_FIELDS_ALL_REQUEST';
export const GET_FIELDS_ALL_SUCCESS = 'GET_FIELDS_ALL_SUCCESS';
export const GET_FIELDS_ALL_ERROR = 'GET_FIELDS_ALL_ERROR';
export const GET_FIELD_REQUEST = 'GET_FIELD_REQUEST';
export const GET_FIELD_SUCCESS = 'GET_FIELD_SUCCESS';
export const GET_FIELD_ERROR = 'GET_FIELD_ERROR';

export const ADD_FIELD_REQUEST = 'ADD_FIELD_REQUEST';
export const ADD_FIELD_SUCCESS = 'ADD_FIELD_SUCCESS';
export const ADD_FIELD_ERROR = 'ADD_FIELD_ERROR';

export const UPDATE_FIELD_REQUEST = 'UPDATE_FIELD_REQUEST';
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS';
export const UPDATE_FIELD_ERROR = 'UPDATE_FIELD_ERROR';
export const CLEAR_FIELD = 'CLEAR_FIELD';

export const DELETE_FIELD_REQUEST = 'DELETE_FIELD_REQUEST';
export const DELETE_FIELD_SUCCESS = 'DELETE_FIELD_SUCCESS';
export const DELETE_FIELD_ERROR = 'DELETE_FIELD_ERROR';
export const DELETE_FIELD_RESET = 'DELETE_FIELD_RESET';

export const SYNC_FIELDS_SUCCESS = 'SYNC_FIELDS_SUCCESS';
